import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absolute bottom-0 inset-x-0 px-container pb-16 lg:pb-32" }
const _hoisted_2 = { class: "font-display text-center" }
const _hoisted_3 = { class: "text-6xl lg:text-8xl text-amff-teal" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" GREEN FILM ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" GREEN FILM ")
const _hoisted_6 = { class: "mt-4 text-center text-2xl lg:text-4xl font-display" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cine sin huella de carbono ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cinema sense petjada de carboni ")
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, " Reducir la huella de carbono para frenar el cambio climático y mitigar el calentamiento global es actualmente uno de los objetivos prioritarios de todos los sectores de la economía. Energías renovables, movilidad sostenible, producto local kilómetro cero... son algunas de las medidas que se aplican para conseguirlo. El cine empieza a incorporar también estos objetivos a sus planes de producción, y muchas películas y programas de televisión aplican ya medidas para reducir su impacto. ‘Green Film’, un sello que distingue a las películas sostenibles, propone una herramienta, una guía objetiva para equilibrar la balanza: producir de forma sostenible, reduciendo las emisiones de CO2 de nuestros rodajes. En Mallorca acaba de iniciarse el ‘Green Film Shooting Plan’, financiado con fondos europeos, para ayudar a las empresas audiovisuales de la isla en esta transición. ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Intervienen:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Lucca FERRARIO"),
    /*#__PURE__*/_createTextVNode(" - Director de Trentino Film Fund y creador del ‘Green Film Rating System’ ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Giovanni POMPILI "),
    /*#__PURE__*/_createTextVNode(" - Coproductor italiano de “Alcarrás”, de Carla Simón, y jefe de estudios de Torino Film Lab ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Diana DE LA CUADRA "),
    /*#__PURE__*/_createTextVNode(" - Productora y coordinadora del plan público de ayudas al sector audiovisual ‘Green Film Shooting Plan’ ")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "Modera:", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Pedro BARBADILLO "),
    /*#__PURE__*/_createTextVNode(" - Director de Mallorca Film Commission y miembro de Green Regio ")
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, " Reduir la petjada de carboni per a frenar el canvi climàtic i mitigar l’escalfament global és actualment un dels objectius prioritaris de tots els sectors de l’economia. Energies renovables, mobilitat sostenible, producte local quilòmetre zero... són algunes de les mesures que s’apliquen per a aconseguir-ho. El cinema comença a incorporar també aquests objectius als seus plans de producció, i moltes pel·lícules i programes de televisió apliquen ja mesures per a reduir el seu impacte. ‘Green Film’, un segell que distingeix a les pel·lícules sostenibles, proposa una eina, una guia objectiva per a equilibrar la balança: produir de manera sostenible, reduint les emissions de CO₂ dels nostres rodatges. A Mallorca acaba d’iniciar-se el ‘Green Film Shooting Pla’, finançat amb fons europeus, per a ajudar a les empreses audiovisuals de l’illa en aquesta transició. ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "Intervienen:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Lucca FERRARIO"),
    /*#__PURE__*/_createTextVNode(" -Director de Trentino Film Fund i creador del ‘Green Film Ràting System’ ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Giovanni POMPILI "),
    /*#__PURE__*/_createTextVNode(" - Coproductor italià de “Alcarrás”, de Carla Simón, i cap d’estudis de Torino Film Lab ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Diana DE LA CUADRA "),
    /*#__PURE__*/_createTextVNode(" - Productora i coordinadora del pla públic d’ajudes al sector audiovisual ‘Green Film Shooting Pla’ ")
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("strong", null, "Modera:", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Pedro BARBADILLO "),
    /*#__PURE__*/_createTextVNode(" - Director de Mallorca Film Commission i membre de Green Regio ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Hero, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h1", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_ctx.currentLang === 'es')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_4
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.currentLang === 'cat')
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_5
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            (_ctx.currentLang === 'es')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_7
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.currentLang === 'cat')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_8
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle),
        (_ctx.currentLang === 'es')
          ? (_openBlock(), _createBlock(_component_PageContent, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _hoisted_14
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_PageContent, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                _hoisted_20
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival)
  ], 64))
}